module.exports = "/images/logo.svg?222622b1ca43ca4191bdff87494aa2f9";